import {
  ActionReducerMapBuilder,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { UserID, UsersResult } from "../interfaces/user.types.ts";
import {
  fetchAllUsers,
  fetchUserByID,
  updateUser,
} from "../actions/usersActions.tsx";

export interface UsersState extends UsersResult {
  loading: boolean;
  activeUser: UserID | null;
}

const initialState = {
  count: 0,
  next: null,
  previous: null,
  results: [],
  loading: false,
  activeUser: null,
} satisfies UsersState as UsersState;

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<UsersState>) => {
    builder
      .addCase(fetchAllUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchAllUsers.fulfilled,
        (state, action: PayloadAction<UsersResult>) => {
          state.loading = false;
          state.count = action.payload.count;
          state.next = action.payload.next;
          state.previous = action.payload.previous;
          state.results = action.payload.results;
        },
      )
      .addCase(fetchAllUsers.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(fetchUserByID.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchUserByID.fulfilled,
        (state, action: PayloadAction<UserID>) => {
          state.loading = false;
          state.activeUser = action.payload;
        },
      )
      .addCase(fetchUserByID.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateUser.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default usersSlice.reducer;
